export default __webpack_public_path__ + "static/media/google-logo-purple.f17e7c10.svg";